import { InsuranceReportApiTypes } from '@frontend/api-insurance-eligibility-report';
import { TableColumnConfig } from '@frontend/design-system';
import { Coverage, ServiceHistory } from './api-response-type';

export enum GridTableEnum {
  COINSURANCE = 'coinsurance',
  COPAYMENT = 'copayment',
  DEDUCTIBLE = 'deductible',
  MAXIMUM = 'maximum',
}

export type CoinsuranceTableDataType = {
  network: string;
  category: string;
  percent: number;
  planPeriod: string;
  disclaimers: string;
  message?: string;
  serviceType?: string;
  insuranceType?: string;
  coverageLevel?: string;
  authorizationRequired?: string;
};

type CoinsuranceTableColConfig = TableColumnConfig<CoinsuranceTableDataType>[];

export type CopaymentTableDataType = {
  network: string;
  category: string;
  amount: number;
  coverageLevel: string;
  disclaimers: string;
};

type CopaymentTableColConfig = TableColumnConfig<CopaymentTableDataType>[];

export type DeductibleTableDataType = {
  network: string;
  category: string;
  coverageLevel: string;
  calendarAmount: number;
  remainingAmount: number;
  disclaimers: string;
  message: string;
  insuranceType: string;
};

type DeductibleTableColConfig = TableColumnConfig<DeductibleTableDataType>[];

export type LimitationTableDataType = {
  coverage: string;
  coverageCategory: string;
  remaining?: string | number;
  planPeriod?: string;
  coverageLevel?: string;
  ageLimit?: string;
  limitation?: string;
  disclaimers?: string;
  limitationAppliesTo?: string;
  serviceDates?: ServiceHistory[];
  insuranceType?: string;
  message?: string;
  procedureCode?: string;
};

type LimitationTableColConfig = TableColumnConfig<LimitationTableDataType>[];

type ProfileDataType = {
  addressLine1?: string;
  addressLine2?: string;
  firstName?: string;
  lastName?: string;
  dateOfBirth?: string;
  planName?: string;
  groupNumber?: string;
  memberId?: string;
  state?: string;
  type?: string;
  coverage?: Coverage;
  payerId?: string;
  payerName?: string;
  city?: string;
  zipCode?: string;
  subscriberId?: string;
  relationship?: string;
};

export type SummaryDataType = {
  title: string;
  subTitle?: string;
  predecessor?: string;
  successor?: string;
  labels: InsuranceReportApiTypes.PlanPeriodValues[] | ['percent'] | ['total', 'remaining', 'paid'];
  percent?: number;
  total?: number;
  remaining?: number;
  paid?: number;
  year_to_date?: number;
  lifetime?: number;
  contract?: number;
  service?: number;
  lifetime_remaining?: number;
  unknown?: number;
  calendar?: number;
  metadata?: {
    network?: string;
    coverageLevel?: string;
  };
};

export type Filters = {
  inNetworkSelected: boolean;
  coverage: string[];
};

export type InsuranceReportContextState = {
  isLoading: boolean;
  coinsuranceTableData: CoinsuranceTableDataType[];
  coinsurancesTableColConfigs: CoinsuranceTableColConfig;
  coinsuranceSummary: SummaryDataType[];
  coPaymentTableData: CopaymentTableDataType[];
  copaymentsTableColConfigs: CopaymentTableColConfig;
  copaymentSummary: SummaryDataType[];
  deductibleTableData: DeductibleTableDataType[];
  deductiblesTableColConfigs: DeductibleTableColConfig;
  deductibleSummary: SummaryDataType[];
  limitationsTableData: LimitationTableDataType[];
  limitationsTableColConfigs: LimitationTableColConfig;
  maximumsSummary?: SummaryDataType[];
  profileData?: ProfileDataType;
  shouldShowCoinsurance?: boolean;
  shouldShowCoPayment?: boolean;
  shouldShowDeductible?: boolean;
  shouldShowMaximums?: boolean;
  shouldShowLimitations?: boolean;
  lastRetrievalDate?: string;
  personImage?: string;
  subscriberData?: ProfileDataType;
  plan?: InsuranceReportApiTypes.InsuranceReportPlanDataType;
  insuranceVerificationRequestMetaData?: InsuranceReportApiTypes.InsuranceReportRequestMetaDataType;
  showNetworkFilter: boolean;
  coverageTypes: string[];
  filters: Filters;
};
